import { DefectType } from "../types/defectType";
import { PalletDetail } from "../types/palletDetail";

const renderTopDefectName = (data: PalletDetail, defectTypes: DefectType[]) => {
    let matchingDefect = defectTypes.find(x => x.defectId === data.topDefectId);
    if (!data.topDefectId || data.topDefectId === 0) {
        return "";
    }
    if (matchingDefect) {
        return `${data.topDefectId}-${matchingDefect.defectName}`;
    }
    return `DefectID: ${data.topDefectId}`;
};

const renderSingleDefectName = (defectId: number, defectTypes: DefectType[]) => {
    let matchingDefect = defectTypes.find(x => x.defectId === defectId);
    if (defectId === 0) {
        return "";
    }
    if (matchingDefect) {
        return `${defectId.toString().padStart(3, '0')}-${matchingDefect.defectName}`;
    }
    return `DefectID: ${defectId}`;
};

const mouldInputCorrect = (input: string) => input.trim().length === 0 || (/^[0-9,.;]+$/.test(input.trim()) && input.split(/[,.;]/).every(x => Number(x) < 100));

export { renderTopDefectName, renderSingleDefectName, mouldInputCorrect };
